import React, {Component} from "react";
import $ from 'jquery'
import styles from "./Calendar.module.css";
import Formatter from "../../utils/Formatter";
import Utils from "../../utils/Utils";

window.$ = $;


export default class Calendar extends Component {
    state = {
        value: this.props.value,
    }

    prepareCalendar() {

        $(document).ready(function () {

            $(".visualizzazione .elemento-visualizzazione .it-date-datepicker").datepicker('disable');

            $(".it-date-datepicker").datepicker({
                inputFormat: ["dd/MM/yyyy"],
                outputFormat: "dd/MM/yyyy",
            });
        });
    }


    componentDidMount() {
        this.prepareCalendar()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.value !== this.props.value) {
            this.setState({value: this.props.value})
        }

        this.prepareCalendar()

    }

    updateCaret(event) {
        const caret = event.target.selectionStart
        let element = event.target
        let updateCaret = event.target.value.length
        if (this.props.value.length - event.target.value.length !== 1) {
            event.target.value =
                Formatter.formatDate(event.target.value, "dd/MM/yyyy")
        }
        updateCaret = event.target.value.length - updateCaret
        window.requestAnimationFrame(() => {
            element.selectionStart = caret + updateCaret
            element.selectionEnd = caret + updateCaret
        })
    }


    render() {
        //console.log("[RENDER] Calendar")
        let cssInput = this.props.error ? styles.inputDataError : this.props.disabled ? [styles.inputData, styles.opacita, "elemento-visualizzazione"].join(" ") : [styles.inputData, "elemento-visualizzazione"].join(" ")
        return (
            <div
                className={"it-datepicker-wrapper "+
                    (this.props.addclass ? this.props.addclass : "")}
                style={{
                    width: this.props.size, backgroundColor: "#ffffff"
                }}
            >
                <div
                    id="date"
                    ref="date"
                    className={[cssInput].join(" ").concat(" form-group ").concat(!Utils.isObjectEmpty(this.props.classes) && this.props.classes.includes("auditField") ? " auditField" : "").concat(this.props.addclass ? this.props.addclass : "")}
                    height="45px"
                >
                    <input
                        onChange={(event) => {
                            this.updateCaret(event);
                            this.props.newCalendar ? this.props.onChange(this.props.id, event) :
                                this.props.onChange(event)
                        }}
                        autoComplete={"off"}
                        onBlur={(event) => {
                            this.props.newCalendar ? this.props.onChange(this.props.id, event) :
                                this.props.onChange(event)
                        }}
                        onFocusCapture={(event) => {
                            this.props.newCalendar ? this.props.onChange(this.props.id, event) :
                                this.props.onChange(event)
                        }}
                        className={["form-control", "it-date-datepicker", "fontSize16", this.props.classes, this.props.required ? styles.placeholder : ""].join(" ").concat(styles.positionDatePicker)}
                        id={this.props.id ? this.props.id : "date1"}
                        type="text"
                        style={{height: "40px"}}
                        placeholder={this.props.placeholder ? this.props.placeholder : this.props.required ? "gg/mm/aaaa*" : "gg/mm/aaaa"}
                        value={this.state.value}
                        disabled={this.props.disabled}
                    />
                </div>
                <label htmlFor={this.props.id ? this.props.id : "date1"} className={"d-none"}/>
                <div style={{
                    marginTop: this.props.ricerca ? "-0.5rem" : "0rem",
                    marginBottom: this.props.ricerca ? "0.6rem" : "0rem"
                }}>
                    {this.props.smallNote &&
                    <span style={{paddingLeft: "20px", marginRight: "10px", color: "#999", fontSize: "12px"}}>
                {this.props.smallNote}
              </span>}
                    {this.props.error && <span className={styles.errorMessage}>
                        {this.props.errorMessage}
                     </span>
                    }
                </div>
            </div>
        )
    }
}
